import React from 'react';
import {
  makeStyles,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Avatar,
  ListItemAvatar,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  useTheme,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { i18n, withTranslation } from 'config/i18n';
import LightBulbHint from 'common/components/LightBulbHint';
import getLocalizedUrl from 'utils/getLocalizedUrl';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    '& .MuiTypography-h2': {
      fontSize: theme.typography.pxToRem(20),
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
  },
  dialogContent: {
    padding: theme.spacing(3, 2, 1),
    '& .MuiTypography-colorTextSecondary': {
      color: theme.palette.secondary.light,
      [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 3, 2),
    },
  },
  dialogActions: {
    padding: theme.spacing(2),
    alignItems: 'flex-end',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 3, 3),
    },
  },
  noteText: {
    fontSize: theme.spacing(1.75),
    '& a': {
      color: theme.palette.secondary.dark,
      fontWeight: 600,
    },
  },
}));

const GetStartedOverlay = ({ t, openDialog, setOpenDialog }) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const handleClosDialoge = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Dialog open={openDialog} onClose={handleClosDialoge} maxWidth="md" fullScreen={fullScreen}>
        <DialogTitle classes={{ root: classes.dialogTitle }}>
          <Typography variant="h2">{t('fe_es_ready_to_list_bike:ready_to_list_bike')}</Typography>
          <IconButton onClick={handleClosDialoge} aria-label="Cancel" color="secondary">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography variant="h5">
            {t('fe_es_ready_to_list_bike:ready_to_list_bike_intro')}
          </Typography>
          <List>
            <ListItem alignItems="flex-start" disableGutters>
              <ListItemAvatar>
                <Avatar>1</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="h4">
                    {t('fe_es_ready_to_list_bike:required_item.title1')}
                  </Typography>
                }
                secondary={t('fe_es_ready_to_list_bike:required_item.des1')}
              />
            </ListItem>
            <ListItem alignItems="flex-start" disableGutters>
              <ListItemAvatar>
                <Avatar>2</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="h4">
                    {t('fe_es_ready_to_list_bike:required_item.title2')}
                  </Typography>
                }
                secondary={t('fe_es_ready_to_list_bike:required_item.des2')}
              />
            </ListItem>
            <ListItem alignItems="flex-start" disableGutters>
              <ListItemAvatar>
                <Avatar>3</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="h4">
                    {t('fe_es_ready_to_list_bike:required_item.title3')}
                  </Typography>
                }
                secondary={t('fe_es_ready_to_list_bike:required_item.des3')}
              />
            </ListItem>
            <ListItem alignItems="flex-start" disableGutters>
              <ListItemAvatar>
                <Avatar>4</Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="h4">
                    {t('fe_es_ready_to_list_bike:required_item.title4')}
                  </Typography>
                }
                secondary={t('fe_es_ready_to_list_bike:required_item.des4')}
              />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Box mb={1}>
            <LightBulbHint withBG>
              <Typography
                className={classes.noteText}
                dangerouslySetInnerHTML={{
                  __html: t('fe_es_ready_to_list_bike:before_start_note', {
                    path: getLocalizedUrl(
                      '/faqs#who-qualifies-to-become-a-commercial-owner',
                      i18n.language
                    ),
                  }),
                }}
              />
            </LightBulbHint>
          </Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClosDialoge}
            classes={{ root: classes.btn }}
            disableElevation
            size="large"
          >
            {t('fe_es_ready_to_list_bike:start')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withTranslation(['fe_es_ready_to_list_bike'])(GetStartedOverlay);
